import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Box, useTheme, InputAdornment, Button } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { useHistory } from "react-router-dom";
import { renderTextField } from "components/FormFields/FieldTypes";
import {
  Required,
  PasswordMatch,
  PasswordValidityMatch,
} from "components/FormFields/validators";
import { homeActions } from "actions";
import SuccessErrorMessagePopUp from "pages/SearchMedication/SuccessErrorMessagePopUp";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";

const ChangePassword = (props) => {
  const theme = useTheme();
  const history = useHistory();
  const {
    formErrors,
    formValues,
    passwordChange,
    changePasswordInfo,
    resetAccountChangeData,
  } = props;
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [successErrorTitle] = useState("Change Password");
  const [successErrorMessage, setSuccessErrorMessage] = useState("");
  const [showSuccessErrorDialog, setShowSuccessErrorDialog] = useState(false);

  const onFormSubmit = () => {
    const params = {
      currentPassword: formValues.currentPassword,
      newPassword: formValues.newPassword,
      // additionalProp3: formValues.confirmPassword,
    };
    passwordChange(params);
  };

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    return () => {
      resetAccountChangeData();
    };
  }, []);

  useEffect(() => {
    if (changePasswordInfo && changePasswordInfo.success) {
      setSuccessErrorMessage(changePasswordInfo.message);
      setShowSuccessErrorDialog(true);
    } else if (
      changePasswordInfo &&
      Object.keys(changePasswordInfo).length &&
      !changePasswordInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(changePasswordInfo.message);
    }
  }, [changePasswordInfo]);

  return (
    <SecondaryCenterTemplate pageTitle="Change Password">
      <Grid container sx={{ paddingTop: "32px" }}>
        <Grid item xs={12} sm={8} sx={{ margin: "auto" }}>
          <form>
            <Grid item container>
              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="currentPassword"
                  isRequired
                  component={renderTextField}
                  label="Please enter your current password"
                  type={showCurrentPassword ? "text" : "password"}
                  validate={Required}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => {
                        setShowCurrentPassword(!showCurrentPassword);
                      }}
                    >
                      {showCurrentPassword ? (
                        <Visibility
                          sx={{ color: theme.palette.primary.main }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ color: theme.palette.primary.main }}
                        />
                      )}
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="newPassword"
                  isRequired
                  component={renderTextField}
                  label="Please select a new memorable password"
                  type={showNewPassword ? "text" : "password"}
                  helperText="6 character minimum, 1 capital letter, 1 number"
                  validate={[Required]}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => {
                        setShowNewPassword(!showNewPassword);
                      }}
                    >
                      {showNewPassword ? (
                        <Visibility
                          sx={{ color: theme.palette.primary.main }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ color: theme.palette.primary.main }}
                        />
                      )}
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="confirmPassword"
                  isRequired
                  component={renderTextField}
                  label="Please confirm your new password"
                  type={showConfirmPassword ? "text" : "password"}
                  validate={[Required, PasswordMatch, PasswordValidityMatch]}
                  endIcon={
                    <InputAdornment
                      position="end"
                      onClick={() => {
                        setShowConfirmPassword(!showConfirmPassword);
                      }}
                    >
                      {showConfirmPassword ? (
                        <Visibility
                          sx={{ color: theme.palette.primary.main }}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ color: theme.palette.primary.main }}
                        />
                      )}
                    </InputAdornment>
                  }
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={10}
                sx={{ margin: "auto", textAlign: "center" }}
              >
                <Box mt={6}>
                  <Button
                    variant="large"
                    onClick={() => onFormSubmit()}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      wordSpacing: 2,
                      minWidth: "100%",
                      backgroundColor:
                        formErrors && Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        formErrors && Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    CHANGE PASSWORD
                  </Button>
                </Box>
              </Grid>
            </Grid>
            {showSuccessErrorDialog ? (
              <SuccessErrorMessagePopUp
                showPopUp={showSuccessErrorDialog}
                message={successErrorMessage}
                title={successErrorTitle}
                onDoneClick={() => {
                  setShowSuccessErrorDialog(false);
                  if (changePasswordInfo && changePasswordInfo.success) {
                    history.push("/MyAccount/Profile");
                  }
                }}
              />
            ) : null}
          </form>
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("CHANGE_PASSWORD_FORM")(state) || {},
    formValues: getFormValues("CHANGE_PASSWORD_FORM")(state),
    OTPValues: getFormValues("OTP_FIELD")(state),
    changePasswordInfo: state.changePassword.data,
  };
};
const mapDispatchToProps = {
  passwordChange: (params) => homeActions.passwordChange(params),
  resetAccountChangeData: () => homeActions.resetAccountChangeData(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "CHANGE_PASSWORD_FORM",
  })(ChangePassword)
);
